import type { WorkItem } from "@/core/api/services";
import { timestampDate } from "@bufbuild/protobuf/wkt";

const contextLabels: Record<string, string> = {
  patient_name: "Patient",
  mrn: "MRN",
  claim_number: "Claim #",
  amount: "Amount",
  payer: "Payer",
  dos: "Date of Service",
  reason: "Reason",
  system: "System",
};

function formatLabel(key: string): string {
  return contextLabels[key] ?? key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

interface ContextSectionProps {
  item: WorkItem;
}

export function ContextSection({ item }: ContextSectionProps) {
  const entries = Object.entries(item.context);
  const isDueSoon = item.dueAt ? timestampDate(item.dueAt) <= new Date(Date.now() + 24 * 60 * 60 * 1000) : false;
  const isOverdue = item.dueAt ? timestampDate(item.dueAt) < new Date() : false;

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
        Details
      </h3>
      <div className="grid grid-cols-2 gap-x-6 gap-y-2">
        {entries.map(([key, value]) => (
          <div key={key}>
            <dt className="text-xs text-gray-500 dark:text-gray-400">
              {formatLabel(key)}
            </dt>
            <dd className="text-sm font-medium text-gray-900 dark:text-gray-100">
              {value}
            </dd>
          </div>
        ))}
        {item.dueAt && (
          <div>
            <dt className="text-xs text-gray-500 dark:text-gray-400">Due</dt>
            <dd
              className={`text-sm font-medium ${
                isOverdue
                  ? "text-red-600 dark:text-red-400"
                  : isDueSoon
                    ? "text-yellow-600 dark:text-yellow-400"
                    : "text-gray-900 dark:text-gray-100"
              }`}
            >
              {timestampDate(item.dueAt).toLocaleDateString()}
            </dd>
          </div>
        )}
      </div>
    </div>
  );
}
